module.exports = __webpack_public_path__ + "static/media/Eye.b0fdad39.svg";